import React from 'react'

function HrisMonthlySalary() {
  return (
    <div>HrisMonthlySalary</div>
  )
}

export default HrisMonthlySalary